const DEFAULT_LOCALE = "en-US";

const numberFormats = new Map<string, Intl.NumberFormat>();

function numberFormat(locale: string, options: Intl.NumberFormatOptions): Intl.NumberFormat {
  const key = `${locale}|${JSON.stringify(options)}`;
  let format = numberFormats.get(key);
  if (!format) {
    format = new Intl.NumberFormat(locale, options);
    numberFormats.set(key, format);
  }
  return format;
}

export function fmtNum(v: number, digits = 0, locale: string = DEFAULT_LOCALE): string {
  return numberFormat(locale, {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  }).format(v);
}

export function fmtEur(v: number, locale: string = DEFAULT_LOCALE): string {
  return numberFormat(locale, {
    style: "currency",
    currency: "EUR",
    maximumFractionDigits: 0,
  }).format(v);
}

export function fmtEurK(v: number, locale: string = DEFAULT_LOCALE): string {
  return numberFormat(locale, {
    style: "currency",
    currency: "EUR",
    notation: "compact",
    maximumFractionDigits: Math.abs(v) >= 1000 && Math.abs(v) < 10000 ? 1 : 0,
  }).format(v);
}
